<template>
  <CContainer>
    <h3>Formulario Contrato de Arrendamiento</h3>
    <CCard class="mt-4">
            <CCardBody>
              <CForm class="p-2">
                <CRow>
                  <CCol col="sm-12">
                    <CAutocomplete
                      label="Cliente: "
                      required
                      :options="directory"
                      :value.sync="rentContract['directorio']"
                      @update:input="newValue => {
                        rentContract['directorio'] = newValue
                        validate()
                      }"
                      @update-search="value => getListDirectory(value)">
                    </CAutocomplete>
                  </CCol>
                  <CCol col="sm-12">
                    <CAutocomplete
                      label="Comercial: "
                      required
                      :options="personal"
                      :value.sync="rentContract['personal']"
                      @update:input="newValue => {
                        rentContract['personal'] = newValue
                        validate()
                      }">
                    </CAutocomplete>
                  </CCol>
                  <CCol col="sm-3">
                    <label class="text-muted font-weight-bold">
                      Fecha Emisi&oacute;n:
                    </label>
                    <DatePicker 
                      type="date" 
                      v-model="rentContract['fecha_Emision']" 
                      value-type="YYYY-MM-DD" 
                      format="DD/MM/YYYY" 
                      placeholder="dd/mm/aaaa"
                      @close="validate" />
                  </CCol>
                  <CCol col="sm-3">
                    <label class="text-muted font-weight-bold">
                      Fecha Vencimiento:
                    </label>
                    <DatePicker
                      type="date"
                      v-model="rentContract['fecha_Vencimiento']"
                      value-type="YYYY-MM-DD"
                      format="DD/MM/YYYY"
                      placeholder="dd/mm/aaaa" />
                  </CCol>
                  <CCol sm="4" class="d-inline-block">
                    <CInput
                      label="Orden Compra:"
                      type="text"
                      addLabelClasses="text-muted font-weight-bold"
                        :value.sync="rentContract['orden_Compra']">
                    </CInput>
                  </CCol>
                </CRow>

                <CRow>
                  <CCol sm="8" class="d-inline-block">
                      <!-- <CInput
                          label="Nombre Archivo Orden Compra:"
                          type="text"
                          addLabelClasses="text-muted font-weight-bold"
                          :value.sync="rentContract['nombre_ArchivoOrdenCompra']">
                      </CInput> -->
                      <!-- <CInputFile
                          @change="files=> file2base64 = files"
                          class="form-group"
                          label="Nombre Archivo Orden Compra:"
                          placeholder=""
                          addLabelClasses="text-muted font-weight-bold col-sm-12" 
                          addInputClasses="col-sm-12" 
                      /> -->
                      <label class="form-label text-muted font-weight-bold" for="customFile">Nombre Archivo Orden Compra:</label>
                      <input type="file" class="form-control" id="customFile" @change="files=> file2base64 = files"/>
                  </CCol>
                  <CCol sm="4" class="d-inline-block">
                      <CSelect 
                          label="Tipo Contrato: "
                          addLabelClasses="text-muted font-weight-bold"
                          :value.sync="rentContract['tipo_Contrato']"
                          :options="[
                              { value: 'A', label: 'Abierto'},
                              { value: 'C', label: 'Cerrado'}
                          ]"
                          @change="() => validate()"
                      />
                    </CCol>
                    <CCollapse :show="rentContract['tipo_Contrato'] === 'C'">
                      <CCol sm="6" class="d-inline-block">
                          <CInput
                              label="Aseguradora: "
                              type="text"
                              addLabelClasses="text-muted font-weight-bold"
                              :value.sync="rentContract['aseguradora']"
                              :disabled="rentContract['tipo_Contrato'] === 'A'"
                              @change="() => validate()"
                              :isValid="rentContract['tipo_Contrato'] === 'A' ? undefined : rentContract['aseguradora'].length > 0">
                          </CInput>
                      </CCol>
                      <CCol sm="6" class="d-inline-block">
                          <CInput
                              label="Número de póliza: "
                              type="text"
                              addLabelClasses="text-muted font-weight-bold"
                              :value.sync="rentContract['numero_Poliza']"
                              :disabled="rentContract['tipo_Contrato'] === 'A'"
                              @change="() => validate()"
                              :isValid="rentContract['tipo_Contrato'] === 'A' ? undefined : rentContract['numero_Poliza'].length > 0">
                          </CInput>
                      </CCol>
                      <CCol sm="6" class="d-inline-block">
                          <CInput
                              label="Fecha póliza:"
                              type="date"
                              addLabelClasses="text-muted font-weight-bold"
                              :value.sync="rentContract['fecha_Poliza']"
                              :disabled="rentContract['tipo_Contrato'] === 'A'"
                              @change="() => validate()"
                              :isValid="rentContract['tipo_Contrato'] === 'A' ? undefined : rentContract['fecha_Poliza'].length > 0">
                          </CInput>
                      </CCol>
                      <CCol sm="6" class="d-inline-block">
                          <CInput
                              label="Vigencia póliza:"
                              type="date"
                              addLabelClasses="text-muted font-weight-bold"
                              :value.sync="rentContract['vigencia_Poliza']"
                              :disabled="rentContract['tipo_Contrato'] === 'A'"
                              @change="() => validate()">
                          </CInput>
                      </CCol>
                      <CCol sm="6" class="d-inline-block">
                          <!-- <CInput
                              label="Valor Asegurado:"
                              type="text"
                              addLabelClasses="text-muted font-weight-bold"
                              :value.sync="assuredValue">
                          </CInput> -->
                          <div class="form-group" role="group">
                              <label for="assuredValue" class="text-muted font-weight-bold">Valor Asegurado:</label>
                              <input type="text"
                                  id="assuredValue"
                                  class="form-control" 
                                  v-mask="currencyMask"
                                  v-model="assuredValue"
                                  @change="(value) => {setRentContractAssuredValue(value)
                                  validate()}"
                                  :disabled="rentContract['tipo_Contrato'] === 'A'"
                                  :class="rentContract['tipo_Contrato'] === 'A' ? '' : rentContract['valor_Asegurado'] > 0 ? 'is-valid' : 'is-invalid'"
                              />
                          </div>
                          
                      </CCol>
                    </CCollapse>
                    <CCol col="sm-6" class="d-inline-block">
                      <span class="text-muted font-weight-bold">Estado:</span>
                      <CSwitch 
                        class="align-middle mx-2"
                        color="dark"
                        shape="pill"
                        variant="opposite"
                        :checked.sync="rentContractStatus"
                        @update:checked="(value) => {
                          rentContract['estado'] = value ? 'A' : 'I'
                        }"/>
                      <span class="font-weight-bold">{{ rentContract["estado"] === "A" ? "Activo" : "Inactivo" }}</span>
                    </CCol>
                </CRow>

              </CForm>
            </CCardBody>
            <CCardFooter>
              <div class="d-flex justify-content-center">
                <CButton
                  color="success"
                  class="mr-2"
                  :class="isValidForm ? '' : 'disabled'"
                  :disabled="!isValidForm"
                  @click="saveRentContractData()">
                  <CIcon name="cil-check-circle" class="mr-2" />
                  <span class="align-middle">Guardar</span>
                </CButton>
                <CButton
                  color="danger"
                  variant="outline"
                  class="mr-2"
                  @click="() => {
                    $router.push({ path: rootPath });
                  }">
                  <CIcon name="cil-x-circle" class="mr-2" />
                  <span class="align-middle">Cancelar</span>
                </CButton>
              </div>
            </CCardFooter>
          </CCard>

    <LoadingCover v-show="loading" />
  </CContainer>
</template>
<script>
  import "vue2-datepicker/index.css";
  import { ref } from "vue";
  import DatePicker from "vue2-datepicker"
  import createNumberMask from 'text-mask-addons/dist/createNumberMask'    
  import LoadingCover from "@/components/containers/LoadingCover.vue";
  import CAutocomplete from "@/components/containers/CAutocomplete";

  import CONSTANTS from "@/constants";
  import { 
    formatter, 
    toBase64 
  } from "@/general";
  import {
    searchDirectorio,
    dataListPersonal,
    obtenerDirectorio
  } from "@/api";
  import { crudContratoArrendamiento } from "@/apis/rents";
    
  const currencyMask = createNumberMask({
    prefix: '$',
    integerLimit: 12,
    allowDecimal: true,
    decimalSymbol: ',',
    thousandsSeparatorSymbol: '.',
    includeThousandsSeparator: true,
    allowNegative: false,
  });

  export default {
    name: "RentContractForm",
    data() {
      return {
        CONSTANTS,
        formatter,
        loading: false,
        rootPath: "",
        isCreate: false,
        isValidForm: false,
        rentContractStatus: true,
        directory: [],
        personal: [],
        currencyMask,
        file2base64: [],
        rentContract: {
          directorio: "",
          personal: "",
          fecha_Emision: "",
          fecha_Vencimiento: "",
          orden_Compra: "",
          nombre_ArchivoOrdenCompra: "",
          archivo_OrdenCompra: "",
          tipo_Contrato: "A",
          aseguradora: "",
          numero_Poliza: "",
          fecha_Poliza: "",
          vigencia_Poliza: "",
          valor_Asegurado: "0",
          estado: "A"
        },
        rentContractId: "",
        rentContractIndex: "",
        assuredValue: 0
      }
    },
    components: {
      DatePicker,
      CAutocomplete,
      LoadingCover
    },
    methods: {
      toBase64,
      async getListDirectory(value) {
        if (value.length > 2) {
          try {
            const response = await searchDirectorio(this, value)

            this.directory = response.map(item => {
              return {
                value: item.id_Directorio,
                label: `${item.empresa} - ${item.identificacion}`
              }
            });
          } catch (error) {
            this.$store.commit("setAlert", {
              color: "danger",
              message: 'Error al cargar datos.',
              show: 5
            });
          }
        }
      },
      async getListPersonal() {
        try {
          const dataPersonal = await dataListPersonal(this, "V")

          this.personal = dataPersonal.map(item => {
            return {
              value: item.id_Personal,
              label: `${item.nombre_Empleado} - ${item.identificacion}`
            }
          });
        } catch {
          this.$store.commit("setAlert", {
            color: "danger",
            message: 'Error al cargar datos',
            show: 5
          });
        }
      },
      async getDirectory(idDirectory) {
        try {
          const { response } = await obtenerDirectorio(this, idDirectory)
          return {
            value: response.id_Directorio,
            label: `${response.empresa} - ${response.identificacion}`
          }
        } catch {
          this.$store.commit("setAlert", {
            color: "danger",
            message: 'Error al cargar datos',
            show: 5
          });
        }
      },
      validate() {
        const staticRequiredFields = ['fecha_Emision', 'directorio', 'personal']
        const requiredFields = this.rentContract['tipo_Contrato'] === 'C' ? staticRequiredFields.concat(['aseguradora', 'numero_Poliza', 'fecha_Poliza', 'valor_Asegurado']) : staticRequiredFields
        this.isValidForm = requiredFields.reduce((acc, key) => {
          const tempVar = this.rentContract[key] ? this.rentContract[key] : ""
          this.rentContract[key] = tempVar
          return acc && (this.rentContract[key].length > 0)
        }, true)
      },
      async getRentContractData(contractId) {
        try {
          return crudContratoArrendamiento(this, "read", contractId);
        } catch {
          this.$store.commit("setAlert", {
            color: "danger",
            message: "Error al cargar datos",
            show: 5
          })
        }
      },
      async saveRentContractData() {
        this.loading = true

        try {
          const processData = {}

          this.rentContract['archivo_OrdenCompra'] = await this.toBase64(this.file2base64).then(file => file)

          Object.keys(this.rentContract).forEach(key => {
            this.rentContract[key] ? processData[key] = this.rentContract[key] : undefined
          })

          if (this.isCreate) {
            const { response } = await crudContratoArrendamiento(this, "create", null, processData);

            this.rentContractId = response.id_ContratoArrendamiento.replaceAll("-", "")
          } else {
            await crudContratoArrendamiento(this, "update", this.rentContractId, processData);
          }

          CONSTANTS.configSimpleConfirm.confirmButtonText = "Agregar"
          CONSTANTS.configSimpleConfirm.confirmButtonColor = "green"

          this.$confirm("¿Desea agregar productos al contrato de arrendamiento?", "Hola Titulo", "question", CONSTANTS.configSimpleConfirm).then(() => {
            this.$router.push({ path: `${this.rootPath}/${this.rentContractId}/productosarrendamientos/agregar` })
          }).catch(() => {
            this.$router.push({ path: this.rootPath });

            this.$store.commit('setAlert', {
              color: "success",
              message: 'Acción exitosa',
              show: 5
            })
          })
        } catch {
          this.$store.commit('setAlert', {
            color: "danger",
            message: this.create ? CONSTANTS.messages.notDoneAdd : CONSTANTS.messages.notDoneEdit,
            show: 5
          })
        } finally {
          this.loading = false
        }
      },
      setRentContractAssuredValue(v) {
        this.rentContract['valor_Asegurado'] = v.target.value.replace("$", "").replaceAll(".", "").replaceAll(",", ".")
      }
    },
    setup() {
      const rootPath = ref("");

      return {
        rootPath
      }
    },
    async mounted() {
      const action = this.$router.currentRoute.fullPath.split("/").at(-1);

      this.rootPath = this.$router.currentRoute.fullPath.replace(`/${action}`, "");
      this.isCreate = action === "agregar";

      // if (!this.$store.state['rentcontracts']) {
      //   this.$router.push({path: '/empresa/movimientos/contratosarrendamientos'})           
      // }

      await this.getListPersonal();

      console.log(this.$router.currentRoute.params.id);

      if (!this.isCreate) {
        this.loading = true;

        try {
          this.rentContractId = this.$router.currentRoute.params.id

          const { response } = await this.getRentContractData(this.rentContractId)
          const rentContractData = response

          this.directory = [await this.getDirectory(rentContractData['directorio'])]

          Object.keys(this.rentContract).forEach(key => {
            this.rentContract[key] = rentContractData[key]
          })

          this.validate()
        } catch (error) {
          this.$store.commit("setAlert", {
            color: "danger",
            message: "NO se pudo cargar los datos del Contrato de Arrendamiento.",
            show: 5
          });
        } finally {
          this.loading = false;
        }
      }
    }
  }
</script>
